const APP_CONST = {
  API: {
    //ZONE SERVICES
    ACCOUNT_INFO: "/account/info",
    CLINIC_USERS: "/clinic/users",
    DOCUMENT_ZONE_DETAILS: "/document/zoneDetail",
    METRICS: "/metrics",
    BASE_VIEDOC_URL: "baseViedocUrl",
    BASE_TEMPLATE_URL: "baseTemplateUrl",
    COLUMN_PREFERENCE: "/userpreference/aggrid",
    //templateService
    ARCHIEVE_FILE: "/archivefile",
    DETAILS: "/detail",
    STATUS: "/status",
    CANCEL: "/cancel",
    TEMPLATE: "/template",
    ZONE_EDIT: "/zone/edit",
    SECTION_EDIT: "/section/edit",
    TEMPLATE_STUDY: "/template/study",
    TEMPLATE_EXPORT: "/template/export",
    TEMPLATE_DELETE: "/template/delete",
    TEMPLATE_RENAME: "/template/org/rename",
    TEMPLATE_SELECT: "/template/select",
    TEMPLATE_INSTANTIATE: "/document/instantiatetemplate",
    STUDY_SELECT: "/template/study/select",
    STUDY_RENAME: "/template/study/rename",
    SELECTED_RENAME: "/template/rename",
    STUDY_DELETE: "/template/study/delete",
    STUDY_EXPORT: "/template/study/export",
    STRUCTURE_EXPORT: "/template/tmfstructure/export",
    STRUCTURE_DELETE: "/tmfstructure/delete",
    DOWNLOAD: "/download",
    DOCUMENT_SAS_GENERATION: "/document/sasgeneration",
    STUDY_INFO_ADMIN: "/studyinfo/admin",
    ETM_LOCK_STATUS: "/etmf/lockstatus",
    ETMFLOCK_LOCK: "/etmflock/lock",
    ETMFLOCK_UNLOCK: `/etmflock/unlock`,
    STUDY_SETTING: "/study/settings",
    ADD_EDIT_ARTIFACT: "/artifact/addoredit",
    TEMPLATE_MAINTAINCE: "/templatemaintenance",
    CHANGES: "/changes",
    TMF_STRUCTURE_REVERT: "/tmfstructure/revert",
    APPLYCHANGES: "/applychanges",
    GETTMFSTRUCTUREDETAILS: "/Structure/gettmfStructuredetails",
    STRUCTURE_EDIT: "/Structure/edit",
    MILESTONES: "/milestones/milestones",
    MILESTONE_LIST: "/artifact/milestones",
    ARTIFACT: "/artifact",
    DATING_CONVENTION: "/artifact/Datingconvention",
    COUNTRY_LIST: "/country/list",
    CLINIC_SITES: "/clinic/sites",
    MILESTONE_FILTER: "/milestones/filter",
    MILESTONE_GROUPS: "/milestones/groups",
    DOCUMENT_DOCUMENTMASTER: "/document/documentmasters",
    documentsharing_TMF: "/documentsharing/tmf",
    CLIENT_DETAILS: "/login/getclientdetails",
    REFRESH_TOKEN: "/token/refreshtoken",
    ETMF_SWITCH_TRACKING: "/template/etmftracking",

    //FILE UPLOAD SERVICES
    DOCUMENT_DOWNLOAD_FILE: "/document/DownloadFile",
    DROPZONE_DOWNLOAD_FILE: "/dropzone/download",
    DOCUMENT_GUID: "/document/GuidCreation",
    DOCUMENT_SAVE: "/document/documentsave",
    //DOCUMENT SERVICES
    ZONE_LIST: "/zone/list",
    MILESTONES_COUNT: "/milestones/count",
    VIDEOC_CLIENT: "/viedocclient/footer",
    STUDY_INFO: "/template/studyinformation",
    SCANNING_STATUS: "/documentscreening/status",
    VIEDOC_INFO: "/viedoc/info",
    DOCUMENT_HISTORY: "/document/getdocumenthistory",
    DOCUMENT_VERSION_LIST: "document/getdocumentversionsbydocid",
    DOCUMENT_DETAILS: "/document/getdocumentdetailsbydocumentversionid",
    DOCUMENT_PREVIEW: "/document/previewfile",
    APP_INIT_CONFIG: "/study/appinitconfig",
    DELETE_DOCUMENT: "/document/delete",
    DOCUMENT_APPROVE: "/document/documentapprovefromawaitreview",
    DOCUMENT_PUBLISH: "/document/documentpublishfromunpublish",
    DOCUMENT_UNPUBLISH: "/document/documentunpublishfromunpublish",
    DOCUMENT_LOCK: "document/lock",
    DOCUMENT_BY_ARTIFACT: "/document",
    DOCUMENT_GET_REVIEW: "/document/getrevieweractiondetail",
    DOCUMENT_SAVE_REVIEW: "/document/saverevieweraction",
    DOCUMENT_CREATE_VERSION: "/documentscreening/createnewversion",
    DOCUMENT_CANCEL_VERSION: "/documentscreening/cancel",
    DOCUMENT_UPDATE: "/document/updatedocumenteditchanges",
    MILESTONE_ARTIFACTS: "milestones/artifacts",
    ADD_EDIT_MILESTONE: "/milestones",
    MOVE_MILESTONE: "milestones/moveup",
    DOCUMENT_CONTENT: "document/getdocumentcontentdetails",
    DOCUMENT_CLONE_SAVE: "document/documentclonesave",
    DOCUMENT_TEMPLATE_VARIABLE: "documenttemplate/variables",

    //DROPZONE
    DROPZONE_DOCUMENTS: "/dropzone",
    DROPZONE_FILE_COUNT: "/dropzone/filecount",
    DROPZONE_DOCUMENT_GUID: "/document/GuidsCreation",
    DROPZONE_SCREENING: "/dropzone/screeningstatus",
    DROPZONE_SCREENING_CANCEL: "/dropzone/cancel",
    DROPZONE_SAVE: "/dropzone",
    FILE_SCREENING: "/filescreeningstatus",
    FILE_SCREENING_CANCEL: "/filescreeningstatus/cancel",

    //AG GRID
    AGGRIDGET_DOCUMENT: "/search/aggridgetdocument",

    //NOTES
    ADD_NOTES: "/document/addnotes",
    GET_NOTES: "/document/getnotesbydocumentversiondropzoneid",
    RESOLVE_NOTE: "/document/resolvenotesbynoteid",
    //AUTH SERVICE
    GET_ROLELIST: "/study/userviews",
    GET_DB_CHECK: "/studyinfo/dbcheck",

    //SHARING_BINDERS
    ADMIN_SHARING_SETTINGS: "document/getadminartifactsharingsettings",
    DOCUMENT_SHARING_METRICS: "document/getsharingbindersmetrics",
    DOCUMENT_SHARING_USERS: "viedoc/docusersinfo",
    EXISTING_SHARED_USER_LIST: "document/getsharingbinderslist",
    SHARED_FILE_COUNT: "sharingfiles/getreciepientsbyfileguid",
    UPDATE_USER_SHARED_LIST: "sharingfiles/addoredit",
    GET_BINDER_DETAILS: "document/getbinderdetails",
    CREATE_BINDER_SHARING: "document/createdocumentsharing",
    BINDER_HISTORY: "document/getbindershistory",
  },
  SELECT_ZONE: "Select zone",
  SELECT_SECTION: "Select section",
  SELECT_ARTIFACT: "Select artifact",
  DOCUMENT_ACTIONS: [
    { value: "Add review comment", label: "Add review comment" },
    { value: "Add note", label: "Add note" },
    { value: "Create new version", label: "Create new version" },
    { value: "Lock document", label: "Lock document" },
    { value: "Delete document", label: "Delete document" },
  ],
  FILE_SIZE: {
    TENMB: 10000000,
  },
  BLACK_LISTED_FILE_FORMATS: [
    "action",
    "apk",
    "app",
    "bat",
    "bin",
    "cmd",
    "com",
    "command",
    "cpl",
    "csh",
    "exe",
    "gadget",
    "inf1",
    "ins",
    "inx",
    "ipa",
    "isu",
    "job",
    "jse",
    "ksh",
    "lnk",
    "msc",
    "msi",
    "msp",
    "mst",
    "osx",
    "out",
    "paf",
    "pif",
    "prg",
    "ps1",
    "reg",
    "rgs",
    "run",
    "scr",
    "sct",
    "shb",
    "shs",
    "u3p",
    "vb",
    "vbe",
    "vbs",
    "vbscript",
    "workflow",
    "ws",
    "wsf",
    "wsh",
    "jad",
    "jar",
    "asp",
    "aspx",
    "cer",
    "cfm",
    "cgi",
    "pl",
    "css",
    "js",
    "jsp",
    "part",
    "php",
    "py",
    "rss",
    "xhtml",
    "jsx",
    "scss",
    "regex",
    "ts",
  ],
  WINDOW_BREAKPOINT: 1200,
  TEXT_NOT_PERMITTED: "Not permitted",
  TEXT_REQUIRED: "Required",
  TEXT_OPTIONAL: "Optional",
  TEXT_NEW: "New",
  AUDIT_TRAIL: "Audit Trail Report",
  EMS_REPO: "TMF - EMS repository",
  OVERVIEW: "Overview",
  DROP_ZONE: "Drop Zone",
  TRAIL_LEVEL_DOCUMENT: "Trial level documents",
  COUNTRY_LEVEL_DOCUMENT: "Country level documents",
  SITE_LEVEL_DOCUMENT: "Site level documents",
  GENERATE_NEW_FILE: "Generate a new file",
  FILTER_BY: "Filter by",
  INCLUDE: "Include",
  MILESTONES: "Milestones",
  RESET: "Reset",
  GENERATE: "Generate",
  DOWNLOAD: "Download",
  FILTER: "Filter",
  ARTIFACTS: "Artifacts",
  SHARED_TEXT: "Shared",
  PRIVATE_TEXT: "Private",
  CONTAINING_DOCUMENTS: "Containing documents",
  MISSING_REQUIRED_DOCUMENTS: "Missing required documents",
  DOCUMENTS: "Documents",
  FLAGGED_BY_QC: "Flagged by QC",
  AWAITING_REVIEW: "Awaiting review",
  FINALIZED: "Finalized",
  DROP_FILES_HERE_CLICK_UPLOAD: "Drop files here or click to upload",
  NAME: "Name",
  TYPE: "Type",
  UPLOADED: "Uploaded",
  TMF_STRUCTURE: "TMF Structure",
  MAINTENANCE: "Maintenance",
  VIEW: "View",
  TMF_STRUCTURE_S: "TMF structure",
  ZONES: "zones",
  SECTIONS: "sections",
  ARTIFACTS_S: "artifacts",
  TMF_TEMPLATES: "Templates",
  TMF_SETTINGS: "Settings",
  VIEW_MILESTONES: "View Milestones",
  ID: "ID",
  TRAIL_DESCRIPTION: "Trial description",
  COUNTRY_DESCRIPTION: "Country description",
  SITE_DESCRIPTION: "Site description",
  OTHER: "Other",
  MAIN_ARTIFACT: "Main artifact",
  STATUS: "Status",
  DATE_TIME_BY_GREG_TULLO: "2022-06-09 22:37 by Greg Tullo (5528)",
  XML: "XML",
  STUDTDESIGN_CONNECT_CONSENT_TBD: "StudyDesign_Connect_&_Consent_TBD.xml",
  UNLOCK_THE_TMF_TO_ENABLE_USERS_TO_WORK_IN_THE_SYSTEM_ACCORDING_TO_THEIR_ROLES_AND_PERMISSIONS:
    "Unlock the TMF to enable users to work in the system according to their roles and permissions.",
  THE_TMF_IS_LOCKED_NO_CHANGES_CAN_BE_MODE_TO_THE_STRUCTURE_OR_DOCUMENTS:
    "The TMF is locked. No changes can be mode to the structure or documents.",
  INSTANTIATED: "Instantiated",
  UNINSTANTIATED: "Locked",
  FILE_AVAILABLE_TEXT:
    "The file is available for download until a new file is generated. Make sure to download the existing file if you need it. Generating a new file will replace the existing one.",
  ADMIN_TEMPLATE_STATUS: ["Selected", "Instantiated", "Maintenance"],
  MILESTONE_GROUP_LIST: ["Start Up", "Study Conduct", "Close Out", "Other"],
  ZONESANDSECTION: "Zones and Sections",
  TMF_SIDE_LIST: [
    { label: "Sponsor", value: "Sponsor" },
    { label: "Investigator", value: "Investigator" },
  ],
  MULTISELECT_VALUES: [
    "All countries",
    "All sites",
    "All milestones",
    "Trial Level",
    "Sponsor",
    "Investigator",
  ],
  FORM_CURRENT_ACTION_ID: [2, 3, 4],
  FORM_CURRENT_ACTION_OBJECT: {
    2: "Added new",
    3: "Edited",
    4: "Deleted",
    5: "Added new",
    6: "Edited",
    7: "Deleted",
    8: "Edited",
    9: "Edited",
  },

  TMF_LEVELS: [
    {
      id: "8ab3bc74-5b5e-43f8-9bab-2b693530a310",
      description: "Site",
    },
    {
      id: "93863545-b158-40c9-a5bc-ac9b688cf438",
      description: "Trial",
    },
    {
      id: "be494877-b66c-40f0-bfe8-f273a165fc55",
      description: "Country",
    },
  ],
  PIE_CHART_1: {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      animation: {
        duration: 1000,
      },
      margin: [0, 0, 0, 0],
      series: [],
      width: 200,
      height: 200,
    },
    credits: {
      enabled: false,
    },
    title: {
      useHTML: true,
      text: "<i class='sprite folder-blue-a-active'></i>",
      align: "center",
      verticalAlign: "middle",
      y: 17,
      style: {
        fontFamily: "MuseoSans, Helvetica, Arial, Verdana, sans-serif",
        fontWeight: "700",
      },
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        borderColor: "#ffffff",
        slicedOffset: 0,
        size: "100%",
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
  },

  PIE_CHART_2: {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      animation: {
        duration: 1000,
      },
      margin: [0, 0, 0, 0],
      series: [],
      width: 200,
      height: 200,
    },
    credits: {
      enabled: false,
    },
    title: {
      useHTML: true,
      text: "<i class='sprite file-default'></i>",
      align: "center",
      verticalAlign: "middle",
      y: 17,
      style: {
        fontFamily: "MuseoSans, Helvetica, Arial, Verdana, sans-serif",
        fontWeight: "700",
      },
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        borderColor: "#ffffff",
        slicedOffset: 0,
        size: "100%",
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
  },

  trialLevelDocuments: [
    {
      value: "Trial Level",
      label: "Trial Level",
    },
  ],

  SELECT_SCOPE: "Select scope",

  SELECT_DOCUMENT_TYPE: "Select record type",
  SELECT_DATING: "Select dating convention",
  DOCUMENT_HISTORY: [
    {
      historyInfo: "Flagged by QC 2023-01-02 09:07 by Maja Olsson (113874987)",
      historyDetails:
        "Comment: Please that the unloaded file is the correct one!",
    },
    {
      historyInfo: "Published 2023-01-01 15:50 by Maja Olsson ",
      historyDetails: "",
    },
  ],
  SIGNATURE_REASON: [
    {
      label: "I have read and understood the contents of the file.",
      value: "I have read and understood the contents of the file.",
    },
    {
      label: "I attest the accuracy of this file.",
      value: "I attest the accuracy of this file.",
    },
    {
      label: "I have reviewed and approve this file.",
      value: "I have reviewed and approve this file.",
    },
    { label: "I agree to the file.", value: "I agree to the file." },
    {
      label: "I attest the accuracy of the wet ink signature.",
      value: "I attest the accuracy of the wet ink signature.",
    },
  ],
  SUBJECT_SIGNATURE_REASON: [
    { label: "I confirm that I have read and understand the contents of the document. I agree to take part in the study.", value: "I confirm that I have read and understand the contents of the document. I agree to take part in the study.", id: 1 },
  ],
  COSIGNATORY_REASON: [
    { label: "I certify that the participant signing this document had the study fully and carefully explained to him/her by me.", value: "I certify that the participant signing this document had the study fully and carefully explained to him/her by me." }
  ],
  TITLE_ARRAY: ["artifactName", "subArtifactName", "customTypeName"],
  HARD_CODED: {
    templateId: "5d4cefab-3a38-40c8-b2f4-5acd4353fede",
    dummyId: "00000000-0000-0000-0000-000000000000",
  },
  ALLOW_TO_UPLOAD: ["WRITE", "SIGN"],
  TEXT_REQUIURED: "Record required",
  TEXT_UNPUBLISHED: "Unpublished",
  TEXT_FLAGGEDBYQC: "Flagged by QC",
  TEXT_FINALIZED: "Finalized",
  TEXT_AWAITINGREVIEW: "Awaiting review",
  TEXT_PUBLISH: "Publish",
  TEXT_LOCK: "Lock",
  TEXT_UNLOCK: "Unlock",
  TEXT_DELETE: "Delete",
  TEXT_ZONE: "zone",
  TEXT_SECTION: "section",
  TEXT_ARTIFACT: "artifact",
  TEXT_UNLOCKDOC: "Unlock document",
  TEXT_LOCKDOC: "Lock document",
  TEXT_DELETEDOC: "Delete document",
  TEXT_ADDNOTE: "Add note",
  TEXT_ADDCOMMENT: "Add review comment",
  TEXT_APPROVE: "Approve",
  TEXT_CREATE_NEW_VERSION: "Create new version",
  TMF_ARCHIVE:"TMF Archive",
  SIDEPANEL_ROUTE:{
    EMS_REPO : "/ems-repo",
    ARCHIVAL : "/archive",
  },
  TEXT_ARCHIVE : "Archive",
  TEXT_AUDIT : "Audit",
  TEXT_ORIGINAL_FILE_NAME : "Original file name",
  TEXT_FILE_SIZE: "File size",
  TEXT_FILE_DATE: "File date",
  TEXT_FILE_VERSION: "File version",
  TEXT_FILE_INTEGRITY: "File integrity",
  TEXT_UPLOAD_VERSION: "upload-version",
  TEXT_RENAMED:"Renamed",
  TEXT_SPONSOR:"Sponsor",
  TEXT_INVESTIGATOR:"Investigator",
  TEXT_ALL_MILESTONE:"All milestones",
  TEXT_STATUS:"status",
  TEXT_MILESTONE:"milestones",
  AGGRID_FIELD: {
    TEXT_PREVIEW : "preview",
    TEXT_AGACTION: "agaction",
    TEXT_DELACTION: "delaction",
  },
  VIEDOC_ICON: {
    ICON_DUMMY_LOCK:"dummy_lock",
    ICON_FLAG:"flag",
    ICON_LOAD:"load",
    ICON_BLOCK:"block",
    ICON_LOCK:"lock",
    ICON_DELETE_OUTLINE: "delete_outlined",
    ICON_VISBILITY: "visibility",
    ICON_DOWNLOAD:"download",
    ICON_VISIBILITY_OFF:"visibility_off"
  }

};

export default APP_CONST;
